






























































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import CutoverplanBaseTabEnvironmentInput from '@/components/FormElements/CutoverplanBaseTabEnvironmentInput.vue';
import { Cutoverplan } from '@/interfaces/Cutoverplan';
import { Environment } from '@/interfaces/Environment';
import CutoverplanBaseTabEnvironmentSelect from '@/components/FormElements/CutoverplanBaseTabEnvironmentSelect.vue';
import { Wave } from '@/interfaces/Wave';

@Component({
  components: { CutoverplanBaseTabEnvironmentSelect, CutoverplanBaseTabEnvironmentInput }
})
export default class EditCutoverplanDefaultTab extends Vue {
  @Prop()
  cutoverplan!: Cutoverplan;

  @Prop()
  selectedEnvironment!: number;

  get allResponsiblesForSelect() {
    return this.$store.state.all_responsibles.map((r: any) => ({ text: r.name, value: r.id }));
  }

  get environments() {
    return [
      { id: null, name: 'DEFAULT' },
      ...this.cutoverplan.environments.map((e) => e.environment)
    ];
  }

  get selectedEnvironmentColor(): string {
    return (
      this.$store.state.all_environments.find((e: Environment) => e.id === this.selectedEnvironment)
        ?.color || '#FFFFFF'
    );
  }

  get waves() {
    return this.$store.state.all_waves.map((w: Wave) => {
      let name = '';
      const preferredLanguage = w.waveLanguages?.find(
        (language: any) => language.languageId === this.$store.state.user.languageId
      );
      if (preferredLanguage) name = preferredLanguage?.name;
      else name = w.waveLanguages?.[0]?.name;
      return {
        text: name,
        value: w.id
      };
    });
  }

  dateMenu = false;
}
